import { HTTPClient } from "../common/HTTPClient";

export interface MigrateExportRequestParams {
  shopId: number;
}

export class MigrateClient {
  constructor(private httpClient: HTTPClient) {}

  public async postCustomers(params: MigrateExportRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/migrates/customers",
      method: "POST",
      data: params
    });

    return data;
  }

  public async postCleanCustomers(
    params: MigrateExportRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/migrates/customers/clean",
      method: "POST",
      data: params
    });

    return data;
  }

  public async postCategories(
    params: MigrateExportRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/migrates/categories",
      method: "POST",
      data: params
    });

    return data;
  }

  public async postItems(params: MigrateExportRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/migrates/items",
      method: "POST",
      data: params
    });

    return data;
  }

  public async postInventories(
    params: MigrateExportRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/migrates/inventories",
      method: "POST",
      data: params
    });

    return data;
  }
}
